export default __webpack_public_path__ + "static/media/copy.847c81dc.svg";